const mapDomain = process.env.VUE_APP_mapDomain       //"https://map-test.adx-co.jp"
const orikomiMapDomain = process.env.VUE_APP_orikomiMapDomain     // "https://orikomi-map.107.jp"

export { mapDomain,  orikomiMapDomain }
